module.exports = __webpack_public_path__ + "img/0259a878942a099e46261bbd49e85608.e34168a4.jpg";